<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="sub-query-modal"
      dialog-width="98vw"
      dialog-height="95vh"
    >
      <template #header>
        {{ ls({ ja: 'サブクエリー', en: 'Subquery' }) }}
      </template>
      <div class="jps-modal-content">
        <div class="search-subquery-modal-header">
          <BaseSelect
            v-model="subValue.c"
            :options="logicOptions"
            class="jps-select"
          />
          <SearchBox :ss="ss" />
          <UiItemSearchResult v-if="ss.searched" :ss="ss" />
        </div>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()" :disabled="!valid">
          {{ ls(dapLangGlobal.ok) }}
        </button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const { testCustomSearch } = useItem()

const logicOptions = [ 'AND', 'OR', 'NOT' ]

interface Props {
  cs?: CustomSearchDefinition
  sub?: SubQuery
}

const props = withDefaults(defineProps<Props>(), {})

const subValue = ref<SubQuery>({
  c: 'AND',
  q: {},
})
const ss: Ref<SearchStore<Item>> = ref(null)
const modal = ref<InstanceType<typeof BaseModal>>()
const _cs: Ref<CustomSearchDefinition> = ref()
const _sub: Ref<SubQuery> = ref()
const openAwait = async (options?: Props) => {
  setOptionsValue(_cs, 'cs', props, options)
  setOptionsValue(_sub, 'sub', props, options)

  ss.value = useSearch<Item>(
    _cs.value,
    testCustomSearch(_cs.value, false, 'P'),
    {
      configNoCache: true,
      configHistory: false,
      configSyncRoute: false,
    },
  )
  ss.value.addAfterSearchListener(r => {
    subValue.value.q = clone(ss.value.state.currentQuery)
  })
  if (_sub.value) {
    subValue.value = clone(_sub.value)
  } else {
    subValue.value = {
      c: 'AND',
      q: {},
    }
  }
  nextTick(() => {
    if (_sub.value) {
      ss.value.restoreQuery(_sub.value.q)
    }
  })
  return await modal.value.openAwait<SubQuery>()
}

const valid = computed(() => {
  return !isEmpty(subValue.value.q)
})
const confirm = () => {
  delete subValue.value.q.csid
  delete subValue.value.q.from
  delete subValue.value.q.size
  delete subValue.value.q.sort
  modal.value.resolve(normalizeEmpty(subValue.value))
}

defineExpose({
  openAwait,
})
</script>

<style lang="scss" scoped>
.sub-query-modal {
  .jps-search-box {
    margin-top: 1.5rem;
  }
}

.search-subquery-modal-header {
  display: flex;
  flex-direction: column;
}
</style>
